import React, { useState, useEffect } from 'react';
import { Document, Packer, Paragraph, HeightRule, TextRun, Header, HorizontalPositionRelativeFrom,SimpleField, PageNumber, NumberFormat, HorizontalPositionAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, TextWrappingType, Table,Footer, TableRow, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign } from "docx";

import { saveAs } from "file-saver";
import RelaysTwo from "./RelaysTwo";
import './RelaysThree.css';
import { API_URL } from "./API";


function FunctionalChecks({ savedGeneralData, goBack, updateFormData, formData, clearAllFormData }) {
  const functionalChecksData = [
    "Wiring checks",
    "Correct operation of appropriate indicator /aux. relay",
    "Correct intiation of alarm contacts",
    "Correct circuit breaker tripping contacts",
    "Relay cover properly fixing",
    "Correct operating reset switch",
    "Relay Draw out conditions CT shorting link should be short",
    "All Binary I/O's and LED indications Checked and found ok"
  ];

  const checkListData = [
    "Check the healthiness of fuses, links, MCCB, Switches, indication lamps, push buttons, space heater & illumination circuit",
    "Check broken glass, switch handle, lamp cover etc.",
    "Check all electrical interlock as per scheme.",
    "Check Mounting of all components i.e. Relays, Meters etc.",
    "Check the fuses for correct rating & mounting.",
    "Checking of breaker for free movement.",
    "Scheme checking as per approved drawings.",
    "Checking of all closing and tripping interlocks",
    "Checking of all contacts used for external system."
  ];


const [functionalValues, setFunctionalValues] = useState(() => {

  try {
    const savedData = localStorage.getItem('functionalChecksData');
    if (savedData) {
      const parsed = JSON.parse(savedData);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (error) {
    console.error("Error loading functional checks:", error);
  }
  

  if (formData?.functionalChecksData && Array.isArray(formData.functionalChecksData) && formData.functionalChecksData.length > 0) {
    return formData.functionalChecksData;
  }
  
 
  return functionalChecksData.map(() => "");
});

const [checkListValues, setCheckListValues] = useState(() => {
 
  try {
    const savedData = localStorage.getItem('checkListData');
    if (savedData) {
      const parsed = JSON.parse(savedData);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (error) {
    console.error("Error loading checklist:", error);
  }
  

  if (formData?.checkListData && Array.isArray(formData.checkListData) && formData.checkListData.length > 0) {
    return formData.checkListData;
  }
  
  
  return checkListData.map(() => "");
});

  const [showBackPage, setShowBackPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  
  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });

  const [allFormData, setAllFormData] = useState({
    formData: {},
    rows: [],
    generalInspection: {},
    settings: {},
    operationalTimeData: {}
  });



  
  useEffect(() => {
    try {
      localStorage.setItem('functionalChecksData', JSON.stringify(functionalValues));
    } catch (error) {
      console.error("Error saving functional checks to localStorage:", error);
    }
  }, [functionalValues]);

  useEffect(() => {
    try {
      localStorage.setItem('checkListData', JSON.stringify(checkListValues));
    } catch (error) {
      console.error("Error saving checklist to localStorage:", error);
    }
  }, [checkListValues]);

  
useEffect(() => {
  try {
    
    const savedFunctionalData = localStorage.getItem('functionalChecksData');
    if (savedFunctionalData) {
      const parsedFunctionalData = JSON.parse(savedFunctionalData);
      if (Array.isArray(parsedFunctionalData) && parsedFunctionalData.length === functionalChecksData.length) {
        setFunctionalValues(parsedFunctionalData);
      }
    }

   
    const savedCheckListData = localStorage.getItem('checkListData');
    if (savedCheckListData) {
      const parsedCheckListData = JSON.parse(savedCheckListData);
      if (Array.isArray(parsedCheckListData) && parsedCheckListData.length === checkListData.length) {
        setCheckListValues(parsedCheckListData);
      }
    }

    const localNavbarData = localStorage.getItem('navbarData'); 
    const localProjectData = localStorage.getItem('createReportData');
    
    if (localNavbarData) {
      const parsedNavbarData = JSON.parse(localNavbarData);
      if (parsedNavbarData.location) {
        setProjectDetails(prev => ({
          ...prev,
          location: parsedNavbarData.location
        }));
      }
    }
  
    if (localProjectData) {
      const parsedProjectData = JSON.parse(localProjectData);
      setProjectDetails({
        subProjectName: parsedProjectData.sub_project_name || "",
        categoryName: parsedProjectData.category_name || "",
        subcategoryName: parsedProjectData.subcategory_name || "",
        equipmentName: parsedProjectData.equipment_name || "",
        projectId: parsedProjectData.project_id || "",
        location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
      });
    }

   
    if (formData?.functionalChecksData && Array.isArray(formData.functionalChecksData)) {
      setFunctionalValues(formData.functionalChecksData);
    }
    
    if (formData?.checkListData && Array.isArray(formData.checkListData)) {
      setCheckListValues(formData.checkListData);
    }
    
  } catch (error) {
    console.error("Error loading data from localStorage:", error);
    setErrorMessage("Failed to load saved data");
  }
}, [formData]); 

useEffect(() => {
 
  const loadSavedData = () => {
    const savedFunctional = localStorage.getItem('functionalChecksData');
    const savedCheckList = localStorage.getItem('checkListData');
    
    if (savedFunctional) {
      try {
        const parsed = JSON.parse(savedFunctional);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setFunctionalValues(parsed);
        }
      } catch (error) {
        console.error("Error loading functional data:", error);
      }
    }
    
    if (savedCheckList) {
      try {
        const parsed = JSON.parse(savedCheckList);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setCheckListValues(parsed);
        }
      } catch (error) {
        console.error("Error loading checklist data:", error);
      }
    }
  };
  
  loadSavedData();
}, []); 
  
  const loadAllFormDataFromStorage = () => {
    try {
      const allFormData = {
        formData: {},
        rows: [],
        generalInspection: {},
        settings: {},
        operationalTimeData: {},
        functionalChecksData: functionalValues,
        checkListData: checkListValues
      };

      
      const mainFormData = localStorage.getItem('relayInspectionData');
      if (mainFormData) {
        const parsedMainFormData = JSON.parse(mainFormData);
        allFormData.formData = parsedMainFormData;
      }

     
      const rowsData = localStorage.getItem('protectionFunctionsData');
      if (rowsData) {
        allFormData.rows = JSON.parse(rowsData);
      }

      const generalInspectionData = localStorage.getItem('generalInspectionData');
      if (generalInspectionData) {
        allFormData.generalInspection = JSON.parse(generalInspectionData);
      }

      const settingsData = localStorage.getItem('relaySettingsData');
      if (settingsData) {
        allFormData.settings = JSON.parse(settingsData);
      }

      const operationalTimeData = localStorage.getItem('operationalTimeData');
      if (operationalTimeData) {
        allFormData.operationalTimeData = JSON.parse(operationalTimeData);
      }

      return allFormData;
    } catch (error) {
      console.error("Error loading form data from localStorage:", error);
      return {
        formData: {},
        rows: [],
        generalInspection: {},
        settings: {},
        operationalTimeData: {},
        functionalChecksData: functionalValues,
        checkListData: checkListValues
      };
    }
  };

  const handleFunctionalChange = (index, value) => {
    const newValues = [...functionalValues];
    newValues[index] = value;
    setFunctionalValues(newValues);
    
   
    try {
      localStorage.setItem('functionalChecksData', JSON.stringify(newValues));
    } catch (error) {
      console.error("Error saving functional checks to localStorage:", error);
    }
  };

  const handleCheckListChange = (index, value) => {
    const newValues = [...checkListValues];
    newValues[index] = value;
    setCheckListValues(newValues);
    
    
    try {
      localStorage.setItem('checkListData', JSON.stringify(newValues));
    } catch (error) {
      console.error("Error saving checklist to localStorage:", error);
    }
  };

  useEffect(() => {
    const autoSave = () => {
      try {
        const formDataToSave = {
          functionalValues: functionalValues,
          checkListValues: checkListValues,
          projectDetails: projectDetails,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('relays_autosave', JSON.stringify(formDataToSave));
      } catch (error) {
        console.error("Auto-save failed:", error);
      }
    };

    const autoSaveInterval = setInterval(autoSave, 30000); 

    return () => clearInterval(autoSaveInterval);
  }, [functionalValues, checkListValues, projectDetails]);

 
  useEffect(() => {
    try {
      const autoSavedData = localStorage.getItem('relays_autosave');
      if (autoSavedData) {
        const parsedData = JSON.parse(autoSavedData);
        if (parsedData.functionalValues && Array.isArray(parsedData.functionalValues)) {
          setFunctionalValues(parsedData.functionalValues);
        }
        if (parsedData.checkListValues && Array.isArray(parsedData.checkListValues)) {
          setCheckListValues(parsedData.checkListValues);
        }
        if (parsedData.projectDetails) {
          setProjectDetails(prev => ({
            ...prev,
            ...parsedData.projectDetails
          }));
        }
      }
    } catch (error) {
      console.error("Error loading auto-saved data:", error);
    }
  }, []);
  
  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formSubmitted) {
        clearAllStorageData();
      }
    };

    const handleUnload = () => {
      if (formSubmitted) {
        clearAllStorageData();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [formSubmitted]);

  const clearAllStorageData = () => {
    try {
      const keysToRemove = [
        'functionalChecksData',
        'checkListData',
        'relayInspectionData',
        'protectionFunctionsData',
        'generalInspectionData',
        'relaySettingsData',
        'operationalTimeData',
        'createReportData',
        'navbarData',
        'relayInspectionReportPdf',
        'relays_autosave'
      ];
      
      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
      });

      console.log("All form data cleared from localStorage");
    } catch (error) {
      console.error("Error clearing localStorage:", error);
    }
  };

  const resetAllFormStates = () => {
    setFunctionalValues(functionalChecksData.map(() => ""));
    setCheckListValues(checkListData.map(() => ""));
    
    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });

    setAllFormData({
      formData: {},
      rows: [],
      generalInspection: {},
      settings: {},
      operationalTimeData: {}
    });

    setFormSubmitted(false);
    setErrorMessage("");
    setSuccessMessage("");
    setShowBackPage(false);
    
    if (clearAllStorageData && typeof clearAllStorageData === 'function') {
      clearAllStorageData();
    }
  };

  const validateAndCleanData = (data) => {
    const cleanData = {};
    
    cleanData.equipment_name = String(data.equipment_name || "Relays");
    cleanData.test_date = String(data.test_date || new Date().toISOString().split('T')[0]);
    cleanData.category_name = String(data.category_name || "Category");
    cleanData.subcategory_name = String(data.subcategory_name || "Subcategory");
    cleanData.sub_project_name = String(data.sub_project_name || "Project");
    cleanData.location = String(data.location || "");
    
    let projectId = data.project_id;
    if (typeof projectId === 'string') {
      projectId = parseInt(projectId.replace(/\D/g, ''));
    }
    cleanData.project_id = Number.isInteger(projectId) && projectId > 0 ? projectId : 1;
    
    if (data.report_file && typeof data.report_file === 'object') {
      cleanData.report_file = {
        report_pdf: String(data.report_file.report_pdf || ""),
        filename: String(data.report_file.filename || `Relay_Test_Report_${Date.now()}.pdf`),
        file_type: String(data.report_file.file_type || "application/pdf")
      };
    }

    if (data.test_data && typeof data.test_data === 'object') {
      cleanData.test_data = {
        formData: data.test_data.formData || {},
        rows: data.test_data.rows || [],
        generalInspection: data.test_data.generalInspection || {},
        settings: data.test_data.settings || {},
        operationalTimeData: data.test_data.operationalTimeData || {},
        functionalChecksData: Array.isArray(data.test_data.functionalChecksData) ? data.test_data.functionalChecksData : [],
        checkListData: Array.isArray(data.test_data.checkListData) ? data.test_data.checkListData : []
      };
    }
    
    return cleanData;
  };

  const createMeaningfulDictionary = (dataArray, descriptionsArray, keyPrefix) => {
    const dictionary = {};
    
    dataArray.forEach((value, index) => {
      if (index < descriptionsArray.length) {
        
        const description = descriptionsArray[index];
        const key = `${keyPrefix}_${index + 1}_${description.toLowerCase()
          .replace(/[^a-zA-Z0-9\s]/g, '') 
          .replace(/\s+/g, '_') 
          .substring(0, 50)}`; 
        
        dictionary[key] = {
          description: description,
          value: value || "",
          index: index
        };
      }
    });
    
    return dictionary;
  };


  const createSimpleDictionary = (dataArray, descriptionsArray) => {
    const dictionary = {};
    

    const valuesArray = Array.isArray(dataArray) ? dataArray : [];
    const descriptionsArr = Array.isArray(descriptionsArray) ? descriptionsArray : [];
    

    descriptionsArr.forEach((description, index) => {
    
      const cleanDescription = String(description).trim();

      const value = index < valuesArray.length ? String(valuesArray[index] || "").trim() : "";
      
 
      if (cleanDescription) {
        dictionary[cleanDescription] = value;
      }
    });
    
    return dictionary;
  };
   
  const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

   const handleSave = async (e) => {
  e.preventDefault();
  setFormSubmitted(true);
  setIsLoading(true);
  setErrorMessage("");
 
  try {
    const loadFormDataSafely = (key, defaultValue = {}) => {
      try {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : defaultValue;
      } catch (error) {
        console.warn(`Error parsing ${key} from localStorage:`, error);
        return defaultValue;
      }
    };
 
    const ensureDictFormat = (data, keyPrefix = 'item') => {
      if (Array.isArray(data)) {
        const dict = {};
        data.forEach((item, index) => {
          if (typeof item === 'object' && item !== null) {
            Object.keys(item).forEach(key => {
              dict[`${keyPrefix}_${index}_${key}`] = item[key];
            });
          } else {
            dict[`${keyPrefix}_${index}`] = item;
          }
        });
        return dict;
      } else if (typeof data === 'object' && data !== null) {
        return data;
      } else {
        return { value: data };
      }
    };
 
    const loadAllFormDataFromStorage = () => {
      return {
        relayInspectionData: loadFormDataSafely('relayInspectionData', {}),
        relaySettingsData: loadFormDataSafely('relaySettingsData', {}),
        operationalTimeData: loadFormDataSafely('operationalTimeData', {}),
        functionalChecksData: loadFormDataSafely('functionalChecksData', []),
        checkListData: loadFormDataSafely('checkListData', []),
        navbarData: loadFormDataSafely('navbarData', {})
      };
    };
 
    const functionalChecksDict = createSimpleDictionary(functionalValues, functionalChecksData);
    const checkListDict = createSimpleDictionary(checkListValues, checkListData);
 
    console.log("Functional Checks Dictionary:", functionalChecksDict);
    console.log("CheckList Dictionary:", checkListDict);
   
    localStorage.setItem('functionalChecksDataDict', JSON.stringify(functionalChecksDict));
    localStorage.setItem('checkListDataDict', JSON.stringify(checkListDict));
 
    const allFormData = loadAllFormDataFromStorage();
    const safeFormData = formData && typeof formData === 'object' ? {
      relayInspectionData: ensureDictFormat(formData.relayInspectionData || allFormData.relayInspectionData, 'inspection'),
      relaySettingsData: ensureDictFormat(formData.relaySettingsData || allFormData.relaySettingsData, 'settings'),
      operationalTimeData: ensureDictFormat(formData.operationalTimeData || allFormData.operationalTimeData, 'operational'),
      functionalChecksData: functionalChecksDict,
      checkListData: checkListDict,
      navbarData: ensureDictFormat(formData.navbarData || allFormData.navbarData, 'navbar')
    } : {
      relayInspectionData: ensureDictFormat(allFormData.relayInspectionData, 'inspection'),
      relaySettingsData: ensureDictFormat(allFormData.relaySettingsData, 'settings'),
      operationalTimeData: ensureDictFormat(allFormData.operationalTimeData, 'operational'),
      functionalChecksData: functionalChecksDict,
      checkListData: checkListDict,
      navbarData: ensureDictFormat(allFormData.navbarData, 'navbar')
    };
 
    console.log("Safe form data with clean dictionaries:", safeFormData);
 
    const wordBlob = await generateWordBlob(safeFormData);
   
    const reader = new FileReader();
    reader.readAsDataURL(wordBlob);
   
    reader.onloadend = async () => {
      try {
        const base64data = reader.result;
        localStorage.setItem('relayTestReportWord', base64data);
       
        const currentDate = new Date().toISOString().split('T')[0];
        const formLocation = safeFormData.relayInspectionData?.location || safeFormData.navbarData?.location || "";
       
        const getProjectId = () => {
          console.log("=== Starting project_id extraction ===");
         
          if (savedGeneralData?.projectData?.project_id) {
            const id = parseInt(savedGeneralData.projectData.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Found project_id in savedGeneralData.projectData:", id);
              return id;
            }
          }
          console.log("✗ No valid project_id in savedGeneralData:", savedGeneralData);
         
          if (projectDetails.projectId) {
            const id = parseInt(projectDetails.projectId);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Found project_id in projectDetails:", id);
              return id;
            }
          }
          console.log("✗ No valid project_id in projectDetails:", projectDetails.projectId);
         
          try {
            const createReportData = localStorage.getItem('createReportData');
            if (createReportData) {
              const parsedData = JSON.parse(createReportData);
              console.log("createReportData from localStorage:", parsedData);
             
              if (parsedData.project_id) {
                const id = parseInt(parsedData.project_id);
                if (!isNaN(id) && id > 0) {
                  console.log("✓ Found project_id in createReportData:", id);
                  return id;
                }
              }
            }
          } catch (error) {
            console.error("Error parsing createReportData:", error);
          }
          console.log("✗ No valid project_id in createReportData");
         
          if (safeFormData.relayInspectionData?.project_id) {
            const id = parseInt(safeFormData.relayInspectionData.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Found project_id in form data:", id);
              return id;
            }
          }
          if (safeFormData.relayInspectionData?.reportNo) {
            const id = parseInt(String(safeFormData.relayInspectionData.reportNo).replace(/\D/g, ''));
            if (!isNaN(id) && id > 0) {
              console.log("✓ Found project_id from reportNo:", id);
              return id;
            }
          }
          console.log("✗ No valid project_id in form data");
         
          console.error(" Could not find valid project_id from any source!");
          console.error("Available data:", {
            savedGeneralData,
            projectDetails,
            formData: safeFormData.relayInspectionData
          });
         
          throw new Error("Unable to determine project ID. Please ensure project is properly selected.");
        };
       
        const projectId = getProjectId();
        console.log("=== Final project_id selected:", projectId, "===");
       
        const apiRequestData = {
          equipment_name: String(projectDetails.equipmentName || safeFormData.relayInspectionData?.equipment || "Relays"),
          test_date: String(safeFormData.relayInspectionData?.date || currentDate),
          category_name: String(projectDetails.categoryName || "Relay"),
          subcategory_name: String(projectDetails.subcategoryName || "Functional Check"),
          sub_project_name: String(projectDetails.subProjectName || safeFormData.relayInspectionData?.project || "Project"),
          project_id: projectId,
          location: String(formLocation || projectDetails.location || ""),
          report_file: {  
            report_word: base64data,
            filename: `Relay_Test_Report_${Date.now()}.docx`,
            file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          },
          test_data: {
            relayGeneralData: safeFormData.relayInspectionData,
            relaySettingsData: safeFormData.relaySettingsData,
            operationalTimeData: safeFormData.operationalTimeData,
            functionalChecksData: safeFormData.functionalChecksData,
            relays_checkList_Data: safeFormData.checkListData  
          }
        };
 
        console.log("=== Final API Request Data ===");
        console.log("Full payload:", JSON.stringify(apiRequestData, null, 2));
        console.log("Project ID type:", typeof apiRequestData.project_id);
        console.log("Project ID value:", apiRequestData.project_id);
   
        const response = await fetch(`${API_URL}/test_report/create_test_report`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(apiRequestData),
          mode: 'cors',
          credentials: 'same-origin',
        });
   
        if (!response.ok) {
          let errorData;
          try {
            errorData = await response.json();
            console.error("Detailed API Error:", errorData);
          } catch (jsonError) {
            console.error("Could not parse error response as JSON:", jsonError);
            errorData = { message: response.statusText };
          }
         
          throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
        }
   
        const result = await response.json();
        console.log('✓ API Response:', result);
   
        alert("Data submitted successfully");
       
      } catch (error) {
        console.error(" Error in Word document processing or API call:", error);
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
   
  } catch (error) {
    console.error(" Error saving data:", error);
   
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage("Cannot connect to server. Please check if the backend is running.");
      alert("Cannot connect to server. Please check if the backend is running.");
    } else if (error.message.includes("generateWordBlob is not defined")) {
      setErrorMessage("Word document generation function is missing. Please check your imports.");
      alert("Word document generation function is missing. Please check your imports.");
    } else if (error.message.includes("Unable to determine project ID")) {
      setErrorMessage(error.message);
      alert(error.message);
    } else {
      setErrorMessage(`Error: ${error.message}`);
      alert(`Error saving data: ${error.message}`);
    }
    setIsLoading(false);
  }
};
 

const generateWordBlob = () => {
  return new Promise((resolve, reject) => {
    try {
      
      const storedFormData = JSON.parse(localStorage.getItem('relayInspectionData') || '{}');
      const settingsFromStorage = JSON.parse(localStorage.getItem('relaySettingsData') || '{}');
      let operationalTimeData = JSON.parse(localStorage.getItem('operationalTimeData') || '{}');

     
      try {
        if (window.operationalTimeData && Object.keys(window.operationalTimeData).length > 0) {
          operationalTimeData = window.operationalTimeData;
        } else if (window.formData && Object.keys(window.formData).length > 0) {
          operationalTimeData = window.formData;
        } else if (window.testResults && Object.keys(window.testResults).length > 0) {
          operationalTimeData = window.testResults;
        } else {
          const storageKeys = ['operationalTimeData', 'formData', 'testResults', 'relayData', 'operationalData'];
          for (let key of storageKeys) {
            try {
              const stored = localStorage.getItem(key);
              if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed && Object.keys(parsed).length > 0) {
                  operationalTimeData = parsed;
                  break;
                }
              }
            } catch (e) {
              console.log(`Error parsing ${key}:`, e);
            }
          }
        }
      } catch (e) {
        console.log('Error accessing data:', e);
      }

     
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };

     
      function findValue(data, searchTerms, defaultValue = "N/A") {
        if (!data || typeof data !== 'object') return defaultValue;
        
        const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];
        
        for (let term of terms) {
          if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
            return data[term];
          }
        }
        
        const dataKeys = Object.keys(data);
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        return defaultValue;
      }

    function getBasicValue(sectionData, fieldSearchTerms, phase) {
        if (!sectionData) return "N/A";
        
        const phaseSpecificTerms = fieldSearchTerms.map(term => `${term}_${phase}`).concat(
          fieldSearchTerms.map(term => `${term}${phase}`),
          fieldSearchTerms.map(term => `${phase}_${term}`),
          fieldSearchTerms.map(term => `${phase}${term}`)
        );
        
        let value = findValue(sectionData, phaseSpecificTerms);
        if (value !== "N/A") return value;
        
        return findValue(sectionData, fieldSearchTerms);
      }

     
      function getInjectedFromIndex(data, phase, multiplier) {
        if (!data) return 'N/A';
        
     
        const fieldMap = {
          '2X': 'injectedCurrent2X',
          '5X': 'injectedCurrent5X',
          '10X': 'injectedCurrent10X'
        };
        
        const fieldName = fieldMap[multiplier];
        if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
          return data[fieldName];
        }
        
        return 'N/A';
      }

      
      function getOperatedFromIndex(data, phase, multiplier) {
        if (!data) return 'N/A';
        
       
        const fieldMap = {
          '2X': 'operatedTime2X',
          '5X': 'operatedTime5X',
          '10X': 'operatedTime10X'
        };
        
        const fieldName = fieldMap[multiplier];
        if (fieldName && data[fieldName] !== undefined && data[fieldName] !== null && data[fieldName] !== '') {
          return data[fieldName];
        }
        
        return 'N/A';
      }

      function safeToString(value) {
        if (value === null || value === undefined || value === '' || value === 'N/A') {
          return "";
        }
        return value.toString();
      }

     
      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
              console.warn("Could not convert image to base64:", error);
              resolve(null);
            }
          };
          img.onerror = function() {
            console.warn("Could not load image from URL:", url);
            resolve(null);
          };
          img.src = url;
        });
      };

     
      let sectionDataOC1 = {};
      const oc1Keys = ['oc1', 'OC1', 'O/C 1', 'oc_1', 'OC_1'];
      for (let key of oc1Keys) {
        if (operationalTimeData[key]) {
          sectionDataOC1 = operationalTimeData[key];
          break;
        }
      }

      let sectionDataOC2 = {};
      const oc2Keys = ['oc2', 'OC2', 'O/C 2', 'oc_2', 'OC_2'];
      for (let key of oc2Keys) {
        if (operationalTimeData[key]) {
          sectionDataOC2 = operationalTimeData[key];
          break;
        }
      }

      let sectionDataEF1 = {};
      const ef1Keys = ['ef1', 'EF1', 'E/F 1', 'ef_1', 'EF_1'];
      for (let key of ef1Keys) {
        if (operationalTimeData[key]) {
          sectionDataEF1 = operationalTimeData[key];
          break;
        }
      }

      let sectionDataEF2 = {};
      const ef2Keys = ['ef2', 'EF2', 'E/F 2', 'ef_2', 'EF_2'];
      for (let key of ef2Keys) {
        if (operationalTimeData[key]) {
          sectionDataEF2 = operationalTimeData[key];
          break;
        }
      }

     
      const createLightWatermark = (base64Data) => {
        return new Promise((resolve) => {
          if (!base64Data) {
            resolve(null);
            return;
          }
          
          try {
            const img = new Image();
            img.onload = function() {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              
              
              ctx.globalAlpha = 0.15;
              ctx.drawImage(img, 0, 0);
              
              const lightDataURL = canvas.toDataURL('image/png');
              const lightBase64 = lightDataURL.split(',')[1];
              resolve(lightBase64);
            };
            img.onerror = function() {
              resolve(null);
            };
            img.src = 'data:image/png;base64,' + base64Data;
          } catch (error) {
            console.warn("Could not create light watermark:", error);
            resolve(null);
          }
        });
      };

     
      const documentSections = [];

      
      const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
      const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg"; 

   
      Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]).then(([logoBase64, watermarkBase64]) => {
        
      
        createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {
        
       
        const headerElements = [];

        if (logoBase64) {
          headerElements.push(
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoBase64,
                              transformation: {
                                width: 80,
                                height: 80
                              }
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                        })
                      ],
                      verticalAlign: VerticalAlign.CENTER,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 20, type: WidthType.PERCENTAGE },
                      margins: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "PIE POWER PRIVATE LIMITED",
                              font: "Times New Roman",
                              color:"#1e402c",
                              bold: true,
                              size: 36
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 80, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ]
            })
          );
        } else {
         
          headerElements.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "PIE POWER PRIVATE LIMITED",
                  font: "Times New Roman",
                  color:"#1e402c",
                  bold: true,
                  size: 36
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            })
          );
        }

        headerElements.push(new Paragraph({ text: "" }));
        documentSections.push(...headerElements);

       


      
        documentSections.push(
                 new Table({
                   width: { size: 100, type: WidthType.PERCENTAGE },
                   rows: [
                     new TableRow({
                       children: [
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                           borders: tableBorders,
                           width: { size: 20, type: WidthType.PERCENTAGE }
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "RELAYS INSPECTION / TEST REPORT " , font: "Courier New", bold: true })] })],
                           borders: tableBorders,
                           width: { size: 50, type: WidthType.PERCENTAGE }
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Date", font: "Courier New", bold: true  })] })],
                           borders: tableBorders,
                           width: { size: 15, type: WidthType.PERCENTAGE }
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER,  children: [new TextRun({ text:  safeToString(storedFormData?.date), font: "Courier New" })] })],
                           borders: tableBorders,
                           width: { size: 15, type: WidthType.PERCENTAGE }
                         })
                       ]
                     }),
                     new TableRow({
                       children: [
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Project", font: "Courier New", bold: true })] })],
                           borders: tableBorders
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(storedFormData?.project), font: "Courier New", bold: true })] })],
                           borders: tableBorders
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Report No", font: "Courier New", bold: true  })] })],
                           borders: tableBorders
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(storedFormData?.reportNo), font: "Courier New" })] })],
                           borders: tableBorders
                         })
                       ]
                     }),
                     new TableRow({
                       children: [
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Customer", font: "Courier New", bold: true })] })],
                           borders: tableBorders
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:   safeToString(storedFormData?.customer), font: "Courier New", bold: true })] })],
                           borders: tableBorders
                         }),
                       
                         new TableCell({
                           children: [new Paragraph({ children: [new TextRun({ text:  " " , font: "Courier New" })] })],
                           borders: tableBorders
                         }),
                          new TableCell({
                           children: [new Paragraph({ children: [new TextRun({ text:  " " , font: "Courier New" })] })],
                           borders: tableBorders
                         }),
                       ]
                     }),
                     new TableRow({
                       children: [
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  "Client", font: "Courier New", bold: true })] })],
                           borders: tableBorders
                         }),
                         new TableCell({
                           children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  safeToString(storedFormData?.client), font: "Courier New", bold: true })] })],
                           borders: tableBorders
                         }),
                         new TableCell({
                           children: [new Paragraph({ children: [new TextRun({ text:  "", font: "Courier New", bold: true })] })],
                           borders: tableBorders
                         }),
                         new TableCell({
                           children: [new Paragraph({ children: [new TextRun({ text:  "", font: "Courier New" })] })],
                           borders: tableBorders
                         })
                       ]
                     })
                   ]
                 })
               );
       

        documentSections.push(new Paragraph({ text: "" })); 

       

      documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "LOCATION:",
                font: "Courier New",
                 bold: true,
                size: 24
              }),
               new TextRun({
                text: " " + safeToString(storedFormData?.location),
                font: "Courier New",
              
                size: 24
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 




       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "NAME PLATE DETAILS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

      
        const nameplateFields = [
          
          { label: "Make", value: storedFormData?.make },
          { label: "Type", value: storedFormData?.type },
          { label: "Serial No", value: storedFormData?.serialNo },
          { label: "Supply Voltage(Uaux)", value: storedFormData?.supplyVoltage },
          { label: "CT Ratio", value: storedFormData?.ctRatio }
        ];

        const nameplateRows = [];

        nameplateFields.forEach(field => {
          nameplateRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: field.label, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  width: { size: 50, type: WidthType.PERCENTAGE },
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(field.value), font: "Courier New" })] })],
                  borders: tableBorders,
                  width: { size: 50, type: WidthType.PERCENTAGE }
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: nameplateRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

        
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Current Transformer Measurements",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

      
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(Amp)", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 40, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Current(Amp)", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 40, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1", font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: storedFormData?.phaseRMeasured || '', font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1", font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: storedFormData?.phaseYMeasured || '', font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "1", font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: storedFormData?.phaseBMeasured || '', font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({
          children: [new TextRun({ text: "", break: 1 })]
        }));

     
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "RELAY SETTINGS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Parameter", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 25, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 1", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 18.75, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 2", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 18.75, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 1", bold: true , font: "Courier New"})] })],
                    borders: tableBorders,
                    width: { size: 18.75, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 2", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 18.75, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "ANSI Code", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_ansiCode || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_ansiCode || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_ansiCode || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_ansiCode || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Value", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_setValue || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_setValue || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_setValue || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_setValue || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Curve Type", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_curveType || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_curveType || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_curveType || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_curveType || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TIME", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc1_time || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.oc2_time || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef1_time || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: settingsFromStorage.ef2_time || 'N/A', font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "OPERATIONAL TIME DATA",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

       
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    shading: {
                    fill: "a6a6a6" 
                  },
                    width: { size: 16.67, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 16.67, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 16.67, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Time(sec)", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 16.67, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 16.67, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 16.67, type: WidthType.PERCENTAGE },
                    shading: {
                    fill: "a6a6a6" 
                  }
                  })
                ]
                }),
          
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 1", bold: true,font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  verticalAlign: VerticalAlign.CENTER
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R",bold: true, font: "Courier New" })] })],
                  borders: tableBorders
                  
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'R')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'R')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'R')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            }),
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y", bold: true, font: "Courier New" })] })],
                  borders: tableBorders
                  
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'Y')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'Y')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'Y')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            }),
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", bold: true, font: "Courier New" })] })],
                  borders: tableBorders
                  
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['setTime', 'time', 'tms'], 'B')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['injected', 'injectedCurrent', 'inject'], 'B')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC1, ['operated', 'operatedTime', 'opTime'], 'B')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          ]
        })
      );

      documentSections.push(new Paragraph({ text: "" })); 

      
      documentSections.push(
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: [
          
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TMS", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  columnSpan: 3
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  columnSpan: 3
                })
              ]
            }),
          
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                })
              ]
            }),
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "O/C 2", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 3
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "R",bold: true,  font: "Courier New" })] })],
                  borders: tableBorders
                  
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'R')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'R')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'R', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            }),
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Y",bold: true,  font: "Courier New" })] })],
                  borders: tableBorders
                  
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'Y')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'Y')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'Y', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            }),
            
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "B", bold: true, font: "Courier New" })] })],
                  borders: tableBorders
                  
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['setCurrent', 'current'], 'B')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataOC2, ['tms', 'TMS', 'time'], 'B')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataOC2, 'B', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          ]
        })
      );

      documentSections.push(new Paragraph({ text: "" }));

     
      documentSections.push(
        new Table({
          width: {
            size: 100,
            type: WidthType.PERCENTAGE,
          },
          rows: [
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  width: { size: 16.67, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  width: { size: 16.67, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  width: { size: 16.67, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Time(sec)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  width: { size: 16.67, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true , font: "Courier New"})] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  width: { size: 16.67, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  width: { size: 16.67, type: WidthType.PERCENTAGE }
                })
              ]
            }),
            
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 1", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "N", bold: true,  font: "Courier New" })] })],
                  borders: tableBorders
                  
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['setTime', 'time', 'tms'], 'N')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['injected', 'injectedCurrent', 'inject'], 'N')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF1, ['operated', 'operatedTime', 'opTime'], 'N')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          ]
        })
      );

      documentSections.push(new Paragraph({ text: "" }));

     
      documentSections.push(
        new Table({
          width: {
            size: 100,
            type: WidthType.PERCENTAGE,
          },
          rows: [
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Set Current(A)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "TMS", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  rowSpan: 2
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Injected Current(A)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  columnSpan: 3
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Operated Time(sec)", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  columnSpan: 3
                })
              ]
            }),
          
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "2X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "5X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "10X", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                })
              ]
            }),
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "E/F 2", bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "N", bold: true,  font: "Courier New" })] })],
                  borders: tableBorders
                 
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF2, ['setCurrent', 'current'], 'N')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getBasicValue(sectionDataEF2, ['tms', 'TMS', 'time'], 'N')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getInjectedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '2X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '5X')), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(getOperatedFromIndex(sectionDataEF2, 'N', '10X')), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          ]
        })
      );

      
      documentSections.push(new Paragraph({ text: "" }));

     
      documentSections.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "FUNCTIONAL CHECKS",
              font: "Courier New",
              bold: true,
              size: 24
            })
          ],
          alignment: AlignmentType.LEFT,
          spacing: { after: 200 }
        })
      );

     
      documentSections.push(
        new Table({
          width: {
            size: 100,
            type: WidthType.PERCENTAGE
          },
          rows: [
          
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({
                    children: [new TextRun({ text: "Check", bold: true, font: "Courier New" })],
                    alignment: AlignmentType.CENTER,
                    
                    shading: {
                    fill: "a6a6a6" 
                  }
                  })],
                  borders: tableBorders,
                  width: { size: 70, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({
                    children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
                    alignment: AlignmentType.CENTER
                  })],
                  borders: tableBorders,
                  width: { size: 30, type: WidthType.PERCENTAGE }
                })
              ]
            }),
            
            
            ...functionalChecksData.map((check, index) => 
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: functionalValues[index] || "N/A", font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            )
          ]
        })
      );

      
      documentSections.push(new Paragraph({ text: "" }));

     
      documentSections.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "CHECK LIST",
              font: "Courier New",
              bold: true,
              size: 24
            })
          ],
          alignment: AlignmentType.LEFT,
          spacing: { after: 200 }
        })
      );

      
      documentSections.push(
        new Table({
          width: {
            size: 100,
            type: WidthType.PERCENTAGE
          },
          rows: [
           
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({
                    children: [new TextRun({ text: "Check Point", bold: true, font: "Courier New" })],
                    alignment: AlignmentType.CENTER
                  })],
                  borders: tableBorders,
                  shading: {
                    fill: "a6a6a6" 
                  },
                  width: { size: 70, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({
                    children: [new TextRun({ text: "Status", bold: true, font: "Courier New" })],
                    alignment: AlignmentType.CENTER
                  })],
                  borders: tableBorders,
                
                  width: { size: 30, type: WidthType.PERCENTAGE }
                })
              ]
            }),
            
           
            ...checkListData.map((check, index) => 
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: check, font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    
                    shading: {
                    fill: "a6a6a6" 
                  }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: checkListValues[index] || "N/A", font: "Courier New" })] })],
                    
                    borders: tableBorders
                  })
                ]
              })
            )
          ]
        })
      );

      documentSections.push(new Paragraph({ text: "" })); 
      
             const convertInchesToTwip = (inches) => {
                return Math.round(inches * 1440);
              };
      
            
const footerTable = new Table({
  width: { size: 100, type: WidthType.PERCENTAGE, },
  alignment: AlignmentType.LEFT,
  rows: [
    new TableRow({
      height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
      children: [
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "Pie Power",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                }),
                new SimpleField({
                  instruction: "PAGE",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                }),
                new SimpleField({
                  instruction: "NUMPAGES",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        })
      ]
    })
  ]
});
 


        const pageBorders = {
  pageBorderTop: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },


  pageBorderRight: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderBottom: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderLeft: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  }
};

      const doc = new Document({
  sections: [
    {
      properties: {
        page: {
          margin: {
            top: convertInchesToTwip(0.5),
            right: convertInchesToTwip(0.5),
            bottom: convertInchesToTwip(1.0),
            left: convertInchesToTwip(0.5)
          },
          borders: pageBorders,
          pageNumbers: {
            start: 1,
            formatType: NumberFormat.DECIMAL
          }
        }
      },
      footers: {
        default: new Footer({
          children: [
            footerTable,
            new Paragraph({
              children: [
                new TextRun({
                  text: "Page ",
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                  children: [PageNumber.CURRENT],
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                    text: " of ",
                    font: "Courier New",
                    size: 16
                  }),
               
                new TextRun({
                  children: [PageNumber.TOTAL_PAGES],
                  font: "Courier New",
                  size: 16
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: {
                before: 200
              }
            })
          ]
        })
      },
      headers: lightWatermarkBase64 ? {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: lightWatermarkBase64,
                  transformation: {
                    width: 500,
                    height: 500
                  },
                  floating: {
                    horizontalPosition: {
                      relative: HorizontalPositionRelativeFrom.PAGE,
                      align: HorizontalPositionAlign.CENTER
                    },
                    verticalPosition: {
                      relative: VerticalPositionRelativeFrom.PAGE,
                      align: VerticalPositionAlign.CENTER
                    },
                    wrap: {
                      type: TextWrappingType.BEHIND_TEXT
                    },
                    allowOverlap: true,
                    behindDocument: true
                  }
                })
              ]
            })
          ]
        })
      } : undefined,
      children: documentSections
    }
  ]
});

      
             
              Packer.toBlob(doc).then(blob => {
                resolve(blob);
              }).catch(error => {
                console.error("Error generating Word blob:", error);
                reject(error);
              });
              });
      
            }).catch(error => {
              console.error("Error fetching logo:", error);
              reject(error);
            });
      
          } catch (error) {
            console.error("Error generating Word blob:", error);
            reject(error);
          }
        });
      };
         





  const handleDownloadPDF = async () => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
     
      const allFormData = JSON.parse(localStorage.getItem('relayInspectionData') || '{}');
      
    
      const safeFormData = formData && typeof formData === 'object' ? formData : allFormData;
      
      const wordBlob = await generateWordBlob(safeFormData, checkListValues);
      saveAs(wordBlob, 'Relay_Inspection_Report.docx');
      
     
        localStorage.removeItem('relayInspectionData');
        
       
          clearAllStorageData();
          resetAllFormStates();
        
        alert("Word document downloaded successfully");
     
      
    } catch (error) {
      console.error("Error generating Word document:", error);
      setErrorMessage(`Error generating Word document: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    setShowBackPage(true);
  };
  
  if (showBackPage) {
    return <RelaysTwo 
      goBack={() => setShowBackPage(false)} 
      savedGeneralData={allFormData}
    />;
  }

  return (
    <div className="ct-9107">
      <div className="ct-9107-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>FUNCTIONAL CHECKS</h2>
        
        <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '10px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
        
      </div>
      
      {errorMessage && (
        <div className="ct-9107-error-message">
          {errorMessage}
        </div>
      )}

      <div className="ct-9107-checks-section">
        {functionalChecksData.map((item, index) => (
          <div className="ct-9107-check-row" key={`func-${index}`}>
            <div className="ct-9107-check-label">{item}</div>
            <div className="ct-9107-check-input">
              <select 
                value={functionalValues[index] || ''} 
                onChange={(e) => handleFunctionalChange(index, e.target.value)}
              >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="ct-9107-header">
        <h2>CHECK LIST</h2>
      </div>

      <div className="ct-9107-check-point-label">Check Point*</div>

      <div className="ct-9107-checks-section">
        {checkListData.map((item, index) => (
          <div className="ct-9107-check-row" key={`list-${index}`}>
            <div className="ct-9107-check-label">{item}</div>
            <div className="ct-9107-check-input">
              <select 
                value={checkListValues[index] || ''} 
                onChange={(e) => handleCheckListChange(index, e.target.value)}
              >
                <option value="">Select</option>
                <option value="OK">OK</option>
                <option value="Not OK">Not OK</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div className="ct-9107-button-container">
        <button type="button" onClick={handleBack} className="ct-9107-back-button" disabled={isLoading}>Back</button>
        <button type="button" className="ct-9107-save-button" onClick={handleSave} disabled={isLoading}>
          {isLoading ? "Processing..." : "Submit"}
        </button>
        
        {formSubmitted && (
          <button 
          type="button"
          className="ct-9107-download-button" 
          onClick={handleDownloadPDF}
          disabled={isLoading}
          style={{ 
            marginLeft: '10px', 
            backgroundColor: '#4CAF50', 
            cursor: isLoading ? 'not-allowed' : 'pointer' 
          }}
        >
          Download Word
        </button>
        )}
      </div>
    </div>
  );
}

export default FunctionalChecks;




















